// extracted by mini-css-extract-plugin
export default {"fee-earner-dropdown":"ns3Au","divider":"EBv4Q","add-rate":"H9z0Q","rate-input":"hsTOq","add-rate-button":"quDzK"};